import React from 'react';
import { Chip as MUIChip, ChipProps, PropTypes, withStyles } from '@material-ui/core';

interface Props extends Omit<ChipProps, 'color'> {
  color?: PropTypes.Color | 'error' | 'success';
}

const RedChip = withStyles((theme) => {
  return {
    root: {
      backgroundColor: theme.palette.error.main,
    },
  };
})(MUIChip);

const GreenChip = withStyles((theme) => {
  return {
    root: {
      backgroundColor: theme.palette.primary.main,
    },
  };
})(MUIChip);

const Chip: React.FC<Props> = (props) => {
  const { color, ...other } = props;

  const getChipComponent = (chipColor: PropTypes.Color | 'error' | 'success') => {
    switch (chipColor) {
      case 'error':
        return RedChip;
      case 'success':
        return GreenChip;
      default:
        return MUIChip;
    }
  };

  const ChipComponent = getChipComponent(props.color ?? 'primary');
  return <ChipComponent {...other} />;
};

export default Chip;
